/* 🤖 this file was generated by svg-to-ts */
export const iconDirections: {
    name: 'directions';
    data: string;
} = {
    name: 'directions',
    data: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 18 22"><path fill="#000" fill-rule="evenodd" d="m9.805.845.087.074 6.713 6.713a1 1 0 0 1 .064.074l-.064-.074a.7.7 0 0 1 .11.846l-.037.057-.026.034-.028.033-.02.02-6.712 6.713a.7.7 0 0 1-1.064-.903l.074-.087 5.517-5.518-11.83-.001.001 11.76a.7.7 0 0 1-.605.694l-.095.006a.7.7 0 0 1-.693-.605l-.007-.095V8.126a.7.7 0 0 1 .605-.693l.095-.006h12.53L8.901 1.909A.7.7 0 0 1 9.805.845"/></svg>`
};
